// import * as types from "./types";

let env = process.env.NODE_ENV;

const locate = {
  "development": {
    // 城山トラストタワー
    lat: 35.664636,
    lng: 139.743108,
  },
  "staging": {
    // 城山トラストタワー
    lat: 35.664636,
    lng: 139.743108,
  },
  "production": {
    // 現地
    lat: 35.455951,
    lng: 139.628344,
  }
};

export const geo = {
  namespaced: true,

  state: {
    lat: locate[env].lat,
    lng: locate[env].lng,
    /**
     * 許容する距離 (km)
     */
    thresholdKM: 0.15
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  }
};
